import {
  AUTH,
  LOGOUT,
  ADD_TOAST_MSG,
  REMOVE_TOAST_MSG,
  CHANGE_LAST_VISITED,
} from "./authTypes";
import app from "../../axiosConfig";
import { LOGOUT_PWA } from "../pwaData/pwaDataTypes";

const dayArray = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const login = ({ userId, password }, navigate) => {
  return async (dispatch) => {
    try {
      const day = new Date().getDay();
      const user = await app.post("/auth/login-pwa/", {
        userId,
        password,
        day: dayArray[day],
      });

      dispatch({
        type: AUTH,
        payload: {
          ...user?.data,
          userData: { ...user?.data.userData, day: dayArray[day] },
        },
      });

      navigate("/Home", { replace: true });
    } catch (error) {
      dispatch(addToastMsg(error?.response?.data?.message, "error"));
    }
  };
};

export const verifyRefreshToken = () => {
  return async (dispatch) => {
    try {
      const day = new Date().getDay();
      const user = await app.get("/auth/refresh-token-pwa", {
        params: { day: dayArray[day] },
      });

      dispatch({
        type: AUTH,
        payload: {
          ...user?.data,
          userData: { ...user?.data.userData, day: dayArray[day] },
        },
      });
    } catch (error) {
      dispatch({ type: LOGOUT });
    }
  };
};

export const signup = ({ fullname, userId, password }, navigate) => {
  return async (dispatch) => {
    try {
      const user = await app.post("/auth/signup", {
        fullname,
        userId,
        password,
      });
      dispatch({ type: AUTH, payload: user?.data });

      navigate("/Home", { replace: true });
    } catch (error) {
      dispatch(addToastMsg(error?.response?.data?.message, "error"));
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    try {
      await app.get("/auth/logout-pwa/");

      dispatch({ type: LOGOUT });
      dispatch({ type: LOGOUT_PWA });
    } catch (error) {
      dispatch(addToastMsg(error?.response?.data?.message, "error"));
    }
  };
};

export const changeLastVisitedAction = (changeLastVisited) => {
  return async (dispatch) => {
    try {
      const { data } = await changeLastVisited();
      dispatch({ type: CHANGE_LAST_VISITED, payload: data?.changeLastVisited });
    } catch (error) {
      dispatch(addToastMsg(error?.response?.data?.message, "error"));
    }
  };
};

export const addToastMsg = (msg, type) => {
  return {
    type: ADD_TOAST_MSG,
    payload: { msg, type },
  };
};

export const removeToastMsg = () => {
  return {
    type: REMOVE_TOAST_MSG,
  };
};
